<!--
 * @Descripttion:
 * @Author: liang
 * @Date: 2021-05-10 16:57:24
 * @LastEditors: liang
 * @LastEditTime: 2021-09-28 10:06:23
-->
<template>
  <div>
    <h1 class="perText1">个人信息</h1>
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm"  label-width="110px">
      <personaledit ref="personaledit" :dataForm='dataForm'></personaledit>
      <div style="padding-left:110px;clear:both;text-align: center;"><el-button type="primary" style="width:100px" @click="dataFormSubmitHandle()" :loading='btnload'>修 改</el-button></div>
    </el-form>
  </div>
</template>

<script>
import personaledit from './personaledit'
import mixins from '@/mixins/index'
export default {
  mixins: [mixins],
  components: { personaledit },
  name: 'personal',
  data () {
    return {
      headUrl: '',
      url: '',
      dataForm: {
        id: '',
        username: '',
        headUrl: '',
        deptId: '',
        deptName: '',
        password: '',
        comfirmPassword: '',
        realName: '',
        gender: 0,
        email: '',
        mobile: '',
        idCard: ''
      },
      btnload: false
    }
  },
  mounted () {
    this.getInfo()
  },
  computed: {
    dataRule () {
      var validatePassword = (rule, value, callback) => {
        if (!this.dataForm.id && !/\S/.test(value)) {
          return callback(new Error('必填项'))
        }
        callback()
      }
      var validateComfirmPassword = (rule, value, callback) => {
        if (!this.dataForm.id && !/\S/.test(value)) {
          return callback(new Error('必填项'))
        }
        if (this.dataForm.password !== value) {
          return callback(new Error('密码不一致'))
        }
        callback()
      }
      var validateEmail = (rule, value, callback) => {
        if (!this.isEmail(value)) {
          return callback(new Error('格式不正确'))
        }
        callback()
      }
      var validateMobile = (rule, value, callback) => {
        if (!this.isMobile(value)) {
          return callback(new Error('格式不正确'))
        }
        callback()
      }
      var validateCardNo = (rule, value, callback) => {
        if (!this.isCardNo(value)) {
          return callback(new Error('格式不正确'))
        }
        callback()
      }
      return {
        username: [
          { required: true, message: '必填项', trigger: 'blur' }
        ],
        password: [
          { validator: validatePassword, trigger: 'blur' }
        ],
        gender: [
          { required: true, trigger: ['blur', 'change'] }
        ],
        comfirmPassword: [
          { validator: validateComfirmPassword, trigger: 'blur' }
        ],
        realName: [
          { required: true, message: '必填项', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '必填项', trigger: 'blur' },
          { validator: validateEmail, trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '必填项', trigger: 'blur' },
          { validator: validateMobile, trigger: 'blur' }
        ],
        idCard: [
          { required: true, message: '必填项', trigger: 'blur' },
          { validator: validateCardNo, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    getInfo () {
      this.$get('/client/personalCenter/getPersonalInfo').then(res => {
        if (res.code === 0) {
          this.dataForm = {
            ...this.dataForm,
            ...res.data
          }
          if (res.data) {
            this.headUrl = process.env.VUE_APP_minio + res.data.headUrl
          }
        }
      })
    },
    handleAvatarSuccess (res, file) {
      this.dataForm.headUrl = res.data.serverPath
      this.headUrl = process.env.VUE_APP_minio + res.data.serverPath
    },
    beforeAvatarUpload (file) {
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      if (!(isJPG || isPNG)) {
        this.$message.error('上传图片只能是 JPG或者PNG 格式!')
      }
      return isJPG || isPNG
    },
    // 表单提交
    dataFormSubmitHandle () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        if (this.dataForm.password.length < 1) {
          if (!this.dataForm.id) {
            this.dataForm.password = ''
            this.dataForm.comfirmPassword = ''
            return this.$message.error('用户登录密码不能为空')
          }
        } else if (this.dataForm.password !== this.dataForm.comfirmPassword) {
          this.dataForm.password = ''
          this.dataForm.comfirmPassword = ''
          return this.$message.error('两次密码不一致！')
        } else if (this.dataForm.password.length < 8) {
          this.dataForm.password = ''
          this.dataForm.comfirmPassword = ''
          return this.$message.error('用户登录密码必须在8位以上')
        } else {
          var value = this.dataForm.password // 得到输入框中的值
          var pattern = /(?!^[0-9]*$)(?!^[a-zA-Z]*$)^([a-zA-Z0-9]{8,})$/ // 创建正则表达式对象
          var flag = pattern.test(value) // 测试匹配

          if (!flag) { // 判断匹配
            this.dataForm.password = ''
            this.dataForm.comfirmPassword = ''
            return this.$message.error('格式错误，请使用数字加字母的格式，请重新输入！')
          }
        }
        this.btnload = true
        this.$post('/client/personalCenter/editUserInfo', this.dataForm).then((res) => {
          this.btnload = false
          if (res.code === 0) {
            this.$message.success('操作成功')
            let user = JSON.parse(localStorage.getItem('user'))
            user.headUrl = this.dataForm.headUrl
            user.idCard = this.dataForm.idCard
            localStorage.setItem('user', JSON.stringify(user))
          }
        }).catch(() => {})
      })
    }
  }
}
</script>
<style scoped>
  .perText1{
    font-size: 22px;
    padding:0 20px;
    padding-bottom: 40px;
  }

</style>
